import React, { useEffect, useState } from "react";
import googleTransliterate from "google-input-tool";

const Transliteration = ({
  name,
  fromDataEnglish,
  fromDataMarathi,
  onChange,
}) => {
  const [inputText, setInputText] = useState(""); // English text
  const [transliteratedText, setTransliteratedText] = useState(""); // Marathi text

  useEffect(() => {
    setInputText(fromDataEnglish);
    setTransliteratedText(fromDataMarathi);
  }, [fromDataEnglish, fromDataMarathi]);
  // Function to handle transliteration
  const handleTransliterate = async (text) => {
    const inputLanguage = "mr-t-i0-und"; // 'mr' is for Marathi language
    const maxResult = 8;

    try {
      // Split the input text into words
      const words = text.split(" ");

      const transliteratedWordsSet = new Set();

      for (const word of words) {
        // Create XMLHttpRequest instance
        let request = new XMLHttpRequest();

        // Call Google Transliterate API
        const response = await googleTransliterate(
          request,
          word,
          inputLanguage,
          maxResult
        );

        // Add the first transliterated suggestion to the Set
        if (response && response.length > 0) {
          transliteratedWordsSet.add(response[0][0]);
        }
      }

      // Combine transliterated words
      const transliteratedResult = Array.from(transliteratedWordsSet).join(" ");

      // Update transliterated text
      setTransliteratedText(transliteratedResult);

      // Send values to parent component (Marathi + English)
      onChange(name, transliteratedResult, text);
    } catch (error) {
      console.error("Transliteration Error: ", error);
    }
  };

  // Handle input change
  const handleInputChange = (e) => {
    // Convert entire input text to uppercase
    const text = e.target.value.toUpperCase(); // Ensure all characters are uppercase
    setInputText(text); // Update English text
    handleTransliterate(text); // Perform transliteration
  };
  const handleKeyDown = (event) => {
    // Check if the Tab key was pressed
    if (event.key === "Tab") {
      // Prevent the default behavior (focus moving to next element)
      // event.preventDefault();

      // Ensure the focus stays on the current input element
      event.target.focus();
    }
  };

  return (
    <div className="row g-2">
      <div className="col-lg-7 col-7">
        <input
          type="text"
          value={inputText}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown} // Prevent focus shift on Tab key
          placeholder="Type here in English..."
          className="form-control capitalized"
        />
      </div>
      <div className="col-lg-5 col-5">
        <input
          type="text"
          className="form-control"
          value={transliteratedText}
        />
      </div>
    </div>
  );
};

export default Transliteration;
